export const encodeState = state => {
  try {
    return window.btoa(JSON.stringify(state));
  } catch (ex) {
    return null;
  }
};

export const decodeState = encodedState => {
  try {
    return JSON.parse(window.atob(encodedState))
  } catch (ex) {
    return null;
  }
};

export const extractGameFromUrl = () => {
  try {
    const searchParams = new URLSearchParams(window.location.search);
    return decodeState(searchParams.get("game"));
  } catch (ex) {
    return null;
  }
};

export const generateUrl = (state, prefix) => {
  const encoded = encodeState(state);
  return prefix + "?game=" + encoded;
};

export const generateUrlForThisPage = state => {
  try {
    return generateUrl(state, window.location.origin + window.location.pathname);
  } catch (ex) {
    return "";
  }
}

export const twitterShare = (message, url) =>
  `http://twitter.com/share?text=${encodeURI(message)}&url=${url}`;


export const facebookShare = url =>
  `http://www.facebook.com/sharer/sharer.php?u=${url}`;



// WEBPACK FOOTER //
// ./src/util/shareGame.js